import React, { useEffect, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import { Link } from "react-router-dom";
import SurveyListHeader from "../../../component/common/layout/SurveyListHeader";
import SurveyListSidebar from "../../../component/common/layout/SurveyListSidebar";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import {
  clearGraphData,
  getCompletionAnalysisData,
  getExitAnalysisData,
  getLeads,
  getQuestionWiseAnalysisData,
  getSurveys,
} from "../../../store/actions/analyticsActions";
import CompletionAnalysis from "./components/CompletionAnalysis";
import MaturityAnalysis from "./components/MaturityAnalysis";
import QuestionWiseAnalysis from "./components/QuestionWiseAnalysis";
import ExitAnalysis from "./components/ExitAnalysis";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { getStages } from "../../../store/actions/variableAction";
import { getSurveyGroups, getSurveyGroupDetail } from "../../../store/actions/surveyGroupAction";
// import echarts from 'echarts';
import { useTranslation } from "react-i18next";
import { apiRequest } from "../../../services/apiService";

export default function Index() {
  //==> STATES <==
  const [filters, setFilters] = useState({
    id: "",
    start: moment().subtract(29, "days"),
    end: moment(),
  });
  const [currentSurvey, setCurrentSurvey] = useState({
    name: null,
    id: null,
    type: null, // 'survey' or 'group'
  });

  const [defaultReport, setDefaultReport] = useState("");
  const [dynamicLeadFields, setDynamicLeadFields] = useState([]);
  //Selectores
  const { surveyData, leadsData } = useSelector((state) => state.analyticsData);
  const { groupList, groupItems } = useSelector((state) => state.surveyGroupData);
  const stages = useSelector((state) => state.variables?.stageData);
  const { t, i18n } = useTranslation();
  console.log("surveyData", surveyData);

  //Others
  const language_code = "22";
  const dispatch = useDispatch();

  const getUTMInfo = (row, key) => {
    if (!row?.su_link_info) return "";

    try {
      let info = row.su_link_info;
      if (typeof info === "string") info = JSON.parse(info);
      if (typeof info === "string") info = JSON.parse(info);

      return info?.[key] ?? "";
    } catch {
      return "";
    }
  };

  // Helper function to get survey name from row data
  const getSurveyName = (row) => {
    if (!row?.survey_name) return "";
    
    try {
      let surveyNameObj = JSON.parse(row.survey_name);
      // Use the language code from the row or default to first available
      const langCode = row.su_languages || Object.keys(surveyNameObj)[0];
      return surveyNameObj[langCode] || Object.values(surveyNameObj)[0] || "";
    } catch {
      return row.survey_name || "";
    }
  };

  const EXCLUDED_STATIC_FIELDS = [
    "HEADING",
    "DESC",
    "SUBMIT",
    "POSITION",
    "PRIVACY",
    "BANNER",
  ];

  const parseJsonSafe = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object") return value;
    try {
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  };

  //Sorting
  const sortString = (a, b) => {
    const strA = (a ?? "").toString().toLowerCase();
    const strB = (b ?? "").toString().toLowerCase();
    if (strA > strB) return 1;
    if (strB > strA) return -1;
    return 0;
  };

  const getLeadDataObject = (row) => {
    if (!row) return {};
    return parseJsonSafe(row.lead_data || row.su_lead_info, {});
  };

  //get lead info
  const getLeadInfo = (data, key) => {
    const value = getLeadDataObject(data);
    return value?.[key] ?? "";
  };

  const formatLeadFieldValue = (row, key) => {
    const value = getLeadInfo(row, key);
    if (key === "TANDC") {
      return value === 1 || value === "1" ? "YES" : "NO";
    }
    return value;
  };

  const getTranslatedFieldLabel = (field) => {
    const labels = parseJsonSafe(field?.su_label_and_options, {});
    const translated = labels?.[language_code] || labels?.["22"];
    return translated || field?.su_name || "";
  };

  const isDynamicLeadField = (field) => {
    if (!field?.su_name) return false;
    if (EXCLUDED_STATIC_FIELDS.includes(field.su_name)) return false;
    if (field.su_name === "TANDC") return false;

    const fieldType = Number(field?.su_form_variable_type);
    if (![1, 3, 4].includes(fieldType)) return false;

    if (fieldType === 1) {
      const options = parseJsonSafe(field?.su_options, {});
      const firstOption = options?.["0"];
      if (firstOption?.type === "hidden") return false;
    }
    return true;
  };

  //Column and data
  const columns = useMemo(() => {
    const baseColumns = [
      {
        name: "S.No.",
        // cell: row => {
        //   return (
        //     <><div className='text-center w-100'>{row.sno}</div></>
        //   )
        // },

        cell: (_row, index) => (
          <div className="text-center w-100">{index + 1}</div>
        ),
        width: "100px",
      },

      // {
      //     name: 'Merketo Id',
      //     cell: row => {
      //         return (
      //             <><div className='text-center w-100'>{row.id}</div></>
      //         )
      //     },
      //     width: "130px",
      // },
      {
        name: t("analytics.date_of_survey"),
        cell: (row) => {
          const date =
            row.su_add_date_time &&
            moment(row.su_add_date_time, "DD-MM-YYYY | hh:mm A").format(
              "DD-MM-YYYY"
            );
          //const date = row.su_add_date_time && moment(row.su_add_date_time).format('YYYY/MM/DD')
          return (
            <>
              <div className="text-center w-100">{date}</div>
            </>
          );
        },
        //width: "150px",
        sortable: true,
        sortFunction: (a, b) => {
          let a1 = a.su_add_date_time && moment(a.su_add_date_time);
          let b1 = b.su_add_date_time && moment(b.su_add_date_time);
          if (a1 > b1) return 1;
          else if (a1 < b1) return -1;
          else return 0;
        },
      },
      {
        name: t("analytics.report_link"),
        cell: (row) => {
          // Use row-specific data if available (for groups), otherwise use component-level data
          const surveyId = row.su_survey_id || currentSurvey.id;
          const reportId = row.default_report || defaultReport;
          const link = `${process.env.REACT_APP_USER_LINK}/report/${surveyId}/${row?.su_survey_submitted_id}/${reportId}`;
          const isDisabled = row.su_is_completed === 0 ? true : false;
          return (
            <>
              <div className="text-center w-100">
                {/* {" "}
                <a href={link} target="_blank" rel="noreferrer">
                  Link
                </a> */}

                <button
                  onClick={() => !isDisabled && window.open(link, "_blank")}
                  className="btn-link"
                  disabled={isDisabled}
                  style={{
                    background: "none",
                    border: "none",
                    color: isDisabled ? "gray" : "blue",
                    textDecoration: "underline",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                  title={
                    isDisabled
                      ? "Link disabled due to incomplete survey"
                      : "Open report link"
                  }
                >
                  {t("analytics.link")}
                </button>
              </div>
            </>
          );
        },
        width: "200px",
      },
      {
        name: "Survey Name",
        cell: (row) => {
          const surveyName = getSurveyName(row);
          return (
            <>
              <div className="text-center w-100">{surveyName}</div>
            </>
          );
        },
       // width: "200px",
        sortable: true,
        sortFunction: (a, b) => {
          let a1 = getSurveyName(a);
          let b1 = getSurveyName(b);
          return sortString(a1, b1);
        },
      },
    ];

    const dynamicColumns = dynamicLeadFields.map((field) => ({
      name: field.label,
      cell: (row) => (
        <div className="text-center w-100">{formatLeadFieldValue(row, field.key)}</div>
      ),
      width: "200px",
      sortable: true,
      sortFunction: (a, b) =>
        sortString(formatLeadFieldValue(a, field.key), formatLeadFieldValue(b, field.key)),
    }));

    const analyticsColumns = [
      {
        name: t("analytics.number_of_responses"),
        cell: (row) => {
          let responses = row.su_survey_response;
          let serialNo = row.su_survey_question_serial_no;
          let response = "0/0";

          if (responses && serialNo) {
            responses = responses.split("#");
            responses = responses?.filter((item) => {
              return item ? true : false;
            });
            responses = responses ? responses.length : 0;
            serialNo = serialNo.split("#")?.length ?? 1;
            response = `${responses}/${Number(serialNo - 1)}`;
          }
          return (
            <>
              <div className="text-center w-100">{response}</div>
            </>
          );
        },
        width: "200px",
      },
      {
        name: t("analytics.maturity_level"),
        cell: (row) => {
          return (
            <>
              <div className="text-center w-100">{row.maturity_stage}</div>
            </>
          );
        },
        width: "200px",
      },
      {
        name: t("analytics.total_score"),
        cell: (row) => {
          // let score = row.su_survey_question_score
          // score = score?.split('#')?.reduce((total, scr) => {
          //     return total + Number(scr)
          // }, 0)

          return (
            <>
              <div className="text-center w-100">{row.score ?? 0}</div>
            </>
          );
        },
        width: "150px",
        sortable: true,
        sortFunction: (a, b) => {
          let a1 = a.su_survey_question_score;
          a1 = a1?.split("#")?.reduce((total, scr) => {
            return total + Number(scr);
          }, 0);
          a1 = a1 ?? 0;
          a1 = a1 + "";

          let b1 = b.su_survey_question_score;
          b1 = b1?.split("#")?.reduce((total, scr) => {
            return total + Number(scr);
          }, 0);
          b1 = b1 ?? 0;
          b1 = b1 + "";

          return sortString(a1, b1);
        },
      },
      {
        name: t("analytics.completed"),
        cell: (row) => {
          let complete = row.su_is_completed;
          complete = complete ? (Number(complete) === 1 ? "YES" : "NO") : "No";
          return (
            <>
              <div className="text-center w-100">{complete}</div>
            </>
          );
        },
        width: "150px",
        sortable: true,
        sortFunction: (a, b) => {
          let a1 = a.su_is_completed;
          a1 = a1 ? (Number(a1) === 1 ? "YES" : "NO") : "No";
          let b1 = b.su_is_completed;
          b1 = b1 ? (Number(b1) === 1 ? "YES" : "NO") : "No";
          return sortString(a1, b1);
        },
      },

      {
        name: t("analytics.unique_id"),
        cell: (row) => {
          return (
            <>
              <div className="text-center w-100">
                {row.su_survey_submitted_id ?? ""}
              </div>
            </>
          );
        },
        width: "140px",
      },

      {
        name: t("analytics.utm_source") || "UTM Source",
        cell: (row) => (
          <div className="text-center w-100">
            {getUTMInfo(row, "utm_source")}
          </div>
        ),
        width: "180px",
        sortable: true,
        sortFunction: (a, b) =>
          sortString(getUTMInfo(a, "utm_source"), getUTMInfo(b, "utm_source")),
      },
      {
        name: t("analytics.utm_medium") || "UTM Medium",
        cell: (row) => (
          <div className="text-center w-100">
            {getUTMInfo(row, "utm_medium")}
          </div>
        ),
        width: "180px",
        sortable: true,
        sortFunction: (a, b) =>
          sortString(getUTMInfo(a, "utm_medium"), getUTMInfo(b, "utm_medium")),
      },
      {
        name: t("analytics.utm_campaign") || "UTM Campaign",
        cell: (row) => (
          <div className="text-center w-100">
            {getUTMInfo(row, "utm_campaign")}
          </div>
        ),
        width: "200px",
        sortable: true,
        sortFunction: (a, b) =>
          sortString(
            getUTMInfo(a, "utm_campaign"),
            getUTMInfo(b, "utm_campaign")
          ),
      },
      {
        name: "Marketing Prefs.",
        cell: (row) => (
          <div className="text-center w-100">{formatLeadFieldValue(row, "TANDC")}</div>
        ),
        width: "180px",
        sortable: true,
        sortFunction: (a, b) =>
          sortString(formatLeadFieldValue(a, "TANDC"), formatLeadFieldValue(b, "TANDC")),
      },
    ];
    return [...baseColumns, ...dynamicColumns, ...analyticsColumns.filter((col) => col?.name)];
  }, [currentSurvey.id, defaultReport, dynamicLeadFields, t]);

  //==> FUNCTIONALITIES <==
  const handleChangeSurvey = (survey_id, name, default_report, type = 'survey') => {
    setFilters({ ...filters, id: survey_id });
    setCurrentSurvey({
      id: survey_id,
      name: name,
      type: type,
    });
    setDefaultReport(default_report);
  };

  const getTopLeads = (data) => {
    let tmpData = data?.map((row) => {
      let score = row.su_survey_question_score;
      score = score?.split("#")?.reduce((total, scr) => {
        return total + Number(scr);
      }, 0);
      score = score ?? 0;

      return {
        ...row,
        score: score,
      };
    });

    tmpData = tmpData?.sort((a, b) => a.score - b.score);
    tmpData = tmpData?.reverse();
    tmpData = tmpData?.slice(0, 10);

    return tmpData;
  };

  const handleCallback = (start, end) => {
    setFilters({ ...filters, start, end });
  };

  // UseMemo to dynamically update ranges based on the selected language
  const ranges = useMemo(
    () => ({
      [t("analytics.today")]: [moment().toDate(), moment().toDate()],
      [t("analytics.yesterday")]: [
        moment().subtract(1, "days").toDate(),
        moment().subtract(1, "days").toDate(),
      ],
      [t("analytics.last7")]: [
        moment().subtract(6, "days").toDate(),
        moment().toDate(),
      ],
      [t("analytics.last30")]: [
        moment().subtract(29, "days").toDate(),
        moment().toDate(),
      ],
      [t("analytics.this")]: [
        moment().startOf("month").toDate(),
        moment().endOf("month").toDate(),
      ],
      [t("analytics.last_month")]: [
        moment().subtract(1, "month").startOf("month").toDate(),
        moment().subtract(1, "month").endOf("month").toDate(),
      ],
    }),
    [i18n.language]
  );

  //==> EFFECTS <==
  useEffect(() => {
    dispatch(getSurveys());
    dispatch(getSurveyGroups());
  }, []);

  // Effect to fetch group details when a group is selected
  useEffect(() => {
    if (currentSurvey.type === 'group' && filters.id) {
      dispatch(getSurveyGroupDetail(filters.id));
    }
  }, [dispatch, currentSurvey.type, filters.id]);

  useEffect(() => {
    if (filters.id && filters.start && filters.end) {
      let start = filters.start?.format("YYYY-MM-DD");
      let end = filters.end?.format("YYYY-MM-DD");
      
      const payload = {
        start,
        end,
      };

      // Add either survey_id or group_id based on type
      if (currentSurvey.type === 'group') {
        payload.group_id = filters.id;
      } else {
        payload.survey_id = filters.id;
      }

      dispatch(getCompletionAnalysisData(payload));
      dispatch(getQuestionWiseAnalysisData(payload));
      dispatch(getExitAnalysisData(payload));
      
      // Fetch stages based on type
      if (currentSurvey.type === 'group') {
        // For groups, fetch stages from the primary survey
        if (groupItems && groupItems.length > 0) {
          const primaryItem = groupItems.find(item => item.su_is_primary === 1);
          const primarySurveyId = primaryItem ? primaryItem.su_survey_id : groupItems[0].su_survey_id;
          
          dispatch(
            getStages({
              survey_id: primarySurveyId,
            })
          );
        }
      } else {
        // For individual surveys
        dispatch(
          getStages({
            survey_id: filters.id,
          })
        );
      }

      dispatch(getLeads(payload));
    } else {
      dispatch(clearGraphData());
    }
  }, [dispatch, filters, currentSurvey.type, groupItems]);

  useEffect(() => {
    const loadDynamicLeadFields = async () => {
      const uniqueSurveyIds = Array.from(
        new Set(
          (leadsData || [])
            .map((row) => row?.su_survey_id)
            .filter(Boolean)
        )
      );

      if (!uniqueSurveyIds.length && !currentSurvey.id) {
        setDynamicLeadFields([]);
        return;
      }

      const fallbackSurveyIds = uniqueSurveyIds.length ? uniqueSurveyIds : [currentSurvey.id];
      const responses = await Promise.all(
        fallbackSurveyIds.map((id) =>
          apiRequest({
            method: "GET",
            url: `/survey/getLeadGenVar?survey_id=${id}`,
          })
        )
      );

      const mergedMap = new Map();
      responses.forEach(({ response }) => {
        const fields = response?.data?.result || [];
        fields.forEach((field) => {
          if (!isDynamicLeadField(field)) return;

          const key = field.su_name;
          if (!mergedMap.has(key)) {
            mergedMap.set(key, {
              key,
              label: getTranslatedFieldLabel(field),
              order: Number(field?.su_order) || 9999,
            });
            return;
          }

          const existing = mergedMap.get(key);
          const fieldOrder = Number(field?.su_order) || 9999;
          if (fieldOrder < existing.order) {
            mergedMap.set(key, {
              ...existing,
              label: getTranslatedFieldLabel(field),
              order: fieldOrder,
            });
          }
        });
      });

      const sortedFields = Array.from(mergedMap.values()).sort((a, b) => {
        if (a.order !== b.order) return a.order - b.order;
        return sortString(a.label, b.label);
      });

      setDynamicLeadFields(sortedFields);
    };

    loadDynamicLeadFields();
  }, [currentSurvey.id, leadsData]);

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper">
        <SurveyListHeader />
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <SurveyListSidebar />
          <div className="flex-grow-1 dashboard-page-outer">
            <div className="dashboard-page-wrap">
              <div className="page-heading d-md-flex align-items-center justify-content-between">
                <div className="head-lef">
                  <h1> {t("analytics.title")}</h1>
                </div>
                <div className="right-wrap d-sm-flex align-items-center mt-2 mt-md-0 sel-sur-wrap">
                  <div className="drop-wrap">
                    <div className="dropdown table-dropdown ques-options mw-220">
                      <button
                        className="btn dropdown-tgl"
                        type="button"
                        id="languages"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <label>
                          {" "}
                          {currentSurvey.name ?? t("analytics.select")}
                        </label>
                      </button>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="languages"
                      >
                        {/* Individual Surveys Section */}
                        {surveyData && surveyData.length > 0 && (
                          <>
                            <div className="dropdown-header">
                              <strong>Individual Survey</strong>
                            </div>
                            {surveyData.map((survey, index) => {
                              let title =
                                survey.survey_name &&
                                JSON.parse(survey.survey_name);
                              title = title ? title[survey.su_languages] : "";
                              return (
                                <span
                                  key={`survey-${index}`}
                                  className="dropdown-item"
                                  onClick={() =>
                                    handleChangeSurvey(
                                      survey.survey_id,
                                      title,
                                      survey.default_report,
                                      'survey'
                                    )
                                  }
                                >
                                  {title}
                                </span>
                              );
                            })}
                          </>
                        )}

                        {/* Survey Groups Section */}
                        {groupList && groupList.length > 0 && (
                          <>
                            {surveyData && surveyData.length > 0 && (
                              <div className="dropdown-divider"></div>
                            )}
                            <div className="dropdown-header">
                              <strong>Survey Group</strong>
                            </div>
                            {groupList.map((group, index) => {
                              return (
                                <span
                                  key={`group-${index}`}
                                  className="dropdown-item"
                                  onClick={() =>
                                    handleChangeSurvey(
                                      group.id,
                                      group.name,
                                      null,
                                      'group'
                                    )
                                  }
                                >
                                  {group.name}
                                </span>
                              );
                            })}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="drop-wrap">
                    <DateRangePicker
                      key={i18n.language}
                      initialSettings={{
                        showDropdowns: true,
                        startDate: filters?.start?.toDate(),
                        endDate: filters?.end?.toDate(),
                        ranges: ranges,
                      }}
                      onCallback={handleCallback}
                    >
                      <div id="reportrange" className="date-range-picker">
                        <label>{t("analytics.date")} - </label>
                        <span>{`${filters?.start?.format(
                          "DD/MM/YY"
                        )} - ${filters?.end?.format("DD/MM/YY")}`}</span>
                      </div>
                    </DateRangePicker>
                  </div>
                </div>
              </div>
              <div className="dashboard-cards-wraper row">
                <div className="col-xl-6 mb__30">
                  <CompletionAnalysis currentSurvey={currentSurvey} />
                </div>
                <div className="col-xl-6 mb__30">
                  <MaturityAnalysis
                    stages={stages}
                    leadsData={leadsData}
                    language_code={language_code}
                    currentSurvey={currentSurvey}
                  />
                </div>
                <div className="col-lg-12 mb__30">
                  <QuestionWiseAnalysis
                    language_code={language_code}
                    survey_id={currentSurvey.id}
                  />
                </div>
                <div className="col-lg-12 mb__30">
                  <ExitAnalysis survey_id={currentSurvey.id} />
                </div>
                <div className="col-lg-12 mb__30">
                  <div className="card dashboard-card min-100 pb-0">
                    <div className="dashboard-card-header d-md-flex justify-content-between align-items-center">
                      <div className="left-wrap">
                        <h3>{t("analytics.top_10_leads.heading")}</h3>
                        <div className="chart-text">
                          <p className="text-data">
                            {t("analytics.top_10_leads.description")}
                          </p>
                        </div>
                      </div>
                      <div className="right-wrap btn-wrap view-more mt-2 mt-md-0">
                        <Link
                          type="button"
                          to={`/admin/analytics/leads${
                            currentSurvey?.id
                              ? currentSurvey.type === 'group'
                                ? `?group_id=${currentSurvey?.id}`
                                : `?survey_id=${currentSurvey?.id}&r=${defaultReport}`
                              : ""
                          }`}
                          className="read-more"
                        >
                          {t("analytics.text1")}
                        </Link>
                      </div>
                    </div>

                    <div className="card-body dashboard-survey-list dashboard-leads-list">
                      <div className="data-table-wrap custom-data-table table-responsive">
                        <DataTable
                          // title="Movies"
                          columns={columns}
                          data={leadsData ? getTopLeads(leadsData) : []}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
